import styles from "./styles";
import { HeaderSearch } from "../../components/HeaderSearch";
import { isArrayEmpty, isStringEmpty } from "../../utils/handler_validations";
import { VeryBtnFill } from "../../components/common/v2/VeryBtnFill";
import { classVeryBtnFill } from "../../components/common/v2/VeryBtnFill/classVeryBtnFill";
import { classVeryIconGoogle } from "../../components/common/v2/VeryIconGoogle/classVeryIconGoogle";
import { useWhitelistContext } from "../../context";
import { VeryTable } from "../../components/common/v2/VeryTable";
import classVeryTable from "../../components/common/v2/VeryTable/classVeryTable";
import { DivLoading } from "../../components/common/DivLoading";
import styled from "styled-components";

const Switch = styled.button`
  position: relative;
  width: 52px;
  height: 28px;
  border-radius: 14px;
  border: none;
  cursor: pointer;
  background: ${(p) => (p.$active ? (p.$color || "#dc2626") : "#d1d5db")};
  transition: background 0.2s;
  flex-shrink: 0;
  &::after {
    content: "";
    position: absolute;
    top: 3px;
    left: ${(p) => (p.$active ? "27px" : "3px")};
    width: 22px;
    height: 22px;
    border-radius: 50%;
    background: #ffffff;
    transition: left 0.2s;
    box-shadow: 0 1px 3px rgba(0,0,0,0.2);
  }
`;

const ContentWhitelistPage = () => {
  const whitelist = useWhitelistContext();
  const listIsEmpty = isArrayEmpty(whitelist.filteredList);
  const shipmentsListIsEmpty = isArrayEmpty(whitelist.filteredShipmentsList);
  const isSearching = !isStringEmpty(whitelist.textInputSearch);
  const pickerResultsEmpty = isArrayEmpty(whitelist.pickerResults.list);

  return (
    <styles.DivMain
      isLoading={whitelist.value.page.loading || whitelist.loadingTesters}
      error={whitelist.value.page.error}
      onClickBtnRetry={() => {
        whitelist.getListInitial();
        whitelist.getTestersInitial();
      }}
    >
      {/* TABS PRINCIPALES */}
      <div style={{
        display: "flex",
        gap: "12px",
        marginBottom: "20px",
        borderBottom: "1px solid #e5e7eb",
        paddingBottom: "10px",
        flexWrap: "wrap"
      }}>
        <button
          onClick={() => whitelist.setMainTab("WHITELIST")}
          style={{
            padding: "10px 20px",
            borderRadius: "6px",
            border: "none",
            cursor: "pointer",
            fontWeight: "600",
            fontSize: "14px",
            backgroundColor: whitelist.mainTab === "WHITELIST" ? "#dc2626" : "transparent",
            color: whitelist.mainTab === "WHITELIST" ? "#ffffff" : "#4b5563",
            transition: "all 0.2s"
          }}
        >
          Whitelist (Mantenimiento General)
        </button>
        <button
          onClick={() => whitelist.setMainTab("SHIPMENTS")}
          style={{
            padding: "10px 20px",
            borderRadius: "6px",
            border: "none",
            cursor: "pointer",
            fontWeight: "600",
            fontSize: "14px",
            backgroundColor: whitelist.mainTab === "SHIPMENTS" ? "#0284c7" : "transparent",
            color: whitelist.mainTab === "SHIPMENTS" ? "#ffffff" : "#4b5563",
            transition: "all 0.2s"
          }}
        >
          Acceso a Envíos (Shipments)
        </button>
        <button
          onClick={() => whitelist.setMainTab("SANDBOX")}
          style={{
            padding: "10px 20px",
            borderRadius: "6px",
            border: "none",
            cursor: "pointer",
            fontWeight: "600",
            fontSize: "14px",
            backgroundColor: whitelist.mainTab === "SANDBOX" ? "#000000" : "transparent",
            color: whitelist.mainTab === "SANDBOX" ? "#ffffff" : "#4b5563",
            transition: "all 0.2s"
          }}
        >
          Sandbox (Modo Aislado / Testers)
        </button>
      </div>

      {/* ========================================================================= */}
      {/* 1. SECCIÓN: WHITELIST GENERAL (MANTENIMIENTO)                             */}
      {/* ========================================================================= */}
      {whitelist.mainTab === "WHITELIST" && (
        <>
          <HeaderSearch
            inputSearch={{
              placeHolder: "Buscar en whitelist general...",
              text: whitelist.textInputSearch,
              onChangeText: (newText) => whitelist.onChangeTextInputSearch(newText),
              onClick: () => whitelist.getListInitial(),
            }}
          >
            <div style={{ marginLeft: "auto" }} />
          </HeaderSearch>

          <div style={{
            backgroundColor: "#ffffff",
            border: "2px solid #dc2626",
            borderRadius: "8px",
            padding: "20px",
            marginBottom: "24px",
            color: "#1f2937",
            fontSize: "14px",
            lineHeight: "1.5",
            display: "flex",
            flexDirection: "column",
            gap: "16px"
          }}>
            <div style={{ fontWeight: "600", color: "#dc2626", display: "flex", alignItems: "center", gap: "8px", fontSize: "16px" }}>
              <span className="material-symbols-outlined" style={{ fontSize: "22px" }}>warning</span>
              Advertencia de Acceso General (Mantenimiento / Whitelist)
            </div>
            <div style={{ color: "#4b5563" }}>
              Activar la whitelist general impedirá que cualquier usuario (pasajero o conductor) inicie sesión o use la app, <strong>a menos</strong> que su número telefónico esté registrado en la tabla inferior.
            </div>

            <div style={{ height: "1px", backgroundColor: "#e5e7eb", margin: "4px 0" }} />

            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                <span style={{ fontWeight: "600", fontSize: "14px", color: "#1f2937" }}>Restringir acceso al sistema (Whitelist ON)</span>
                <span style={{ fontSize: "12px", color: "#6b7280" }}>
                  Estado actual en base de datos: {whitelist.value.enabled ? "⛔ Acceso Restringido (Whitelist activa)" : "✅ Acceso Libre (Todos los usuarios)"}
                </span>
              </div>
              <Switch
                $active={whitelist.enabledLocal}
                $color="#dc2626"
                onClick={() => whitelist.setEnabledLocal((prev) => !prev)}
              />
            </div>

            <div style={{ display: "flex", flexDirection: "column", gap: "6px", marginTop: "4px" }}>
              <label style={{ fontWeight: "600", color: "#1f2937" }}>Mensaje de Bloqueo para Usuarios no autorizados:</label>
              <div style={{ display: "flex", gap: "10px", alignItems: "center", width: "100%" }}>
                <input
                  type="text"
                  value={whitelist.blockedMessage}
                  onChange={(e) => whitelist.setBlockedMessage(e.target.value)}
                  placeholder="Ej: Apps en mantenimiento, el servicio se restablecerá a las 8:00pm"
                  style={{
                    flex: 1,
                    backgroundColor: "#ffffff",
                    border: "1px solid #d1d5db",
                    borderRadius: "6px",
                    padding: "8px 12px",
                    color: "#1f2937",
                    outline: "none"
                  }}
                />
                <div style={{ flexShrink: 0 }}>
                  <VeryBtnFill
                    colorTheme={classVeryBtnFill.COLOR_THEME.BLACK_S1}
                    label="Guardar cambios"
                    onClick={() => whitelist.saveWhitelistConfig()}
                  />
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {/* ========================================================================= */}
      {/* 2. SECCIÓN: ACCESO A ENVÍOS (SHIPMENTS)                                   */}
      {/* ========================================================================= */}
      {whitelist.mainTab === "SHIPMENTS" && (
        <>
          <HeaderSearch
            inputSearch={{
              placeHolder: "Buscar en lista de envíos...",
              text: whitelist.shipmentsSearchText,
              onChangeText: (newText) => whitelist.setShipmentsSearchText(newText),
              onClick: () => whitelist.getListInitial(),
            }}
          >
            <div style={{ marginLeft: "auto" }} />
          </HeaderSearch>

          <div style={{
            backgroundColor: "#ffffff",
            border: "2px solid #0284c7",
            borderRadius: "8px",
            padding: "20px",
            marginBottom: "24px",
            color: "#1f2937",
            fontSize: "14px",
            lineHeight: "1.5",
            display: "flex",
            flexDirection: "column",
            gap: "16px"
          }}>
            <div style={{ fontWeight: "600", color: "#0284c7", display: "flex", alignItems: "center", gap: "8px", fontSize: "16px" }}>
              <span className="material-symbols-outlined" style={{ fontSize: "22px" }}>local_shipping</span>
              Control y Acceso Exclusivo a Very Envíos
            </div>
            <div style={{ color: "#4b5563" }}>
              Controla la disponibilidad del servicio de envíos de forma independiente a la app general. Puedes habilitarlo para todos o activar el <strong>Modo Lista Restringida</strong> para que solo los números en la tabla inferior tengan acceso exclusivo a cotizar y solicitar envíos.
            </div>

            <div style={{ height: "1px", backgroundColor: "#e5e7eb", margin: "4px 0" }} />

            {/* SWITCH 1: GLOBAL */}
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                <span style={{ fontWeight: "600", fontSize: "14px", color: "#1f2937" }}>1. Habilitar Servicio de Envíos Globalmente (ALLOW_SHIPMENTS)</span>
                <span style={{ fontSize: "12px", color: whitelist.allowShipmentsGlobal ? "#059669" : "#d97706" }}>
                  Estado actual: {whitelist.allowShipmentsGlobal ? "✅ Envíos Habilitados de forma general" : "⛔ Envíos Deshabilitados de forma general"}
                </span>
              </div>
              <Switch
                $active={whitelist.allowShipmentsGlobal}
                $color="#059669"
                onClick={() => whitelist.setAllowShipmentsGlobal((prev) => !prev)}
              />
            </div>

            <div style={{ height: "1px", backgroundColor: "#e5e7eb", margin: "4px 0" }} />

            {/* SWITCH 2: SHIPMENTS WHITELIST MODE */}
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                <span style={{ fontWeight: "600", fontSize: "14px", color: "#1f2937" }}>2. Modo Lista Exclusiva de Envíos (SHIPMENTS_WHITELIST ON)</span>
                <span style={{ fontSize: "12px", color: whitelist.shipmentsEnabledLocal ? "#0284c7" : "#6b7280" }}>
                  {whitelist.shipmentsEnabledLocal
                    ? "🔒 Modo Lista Activo: Solo los números registrados en la tabla de envíos pueden usar el servicio"
                    : "🌐 Modo Lista Inactivo: Aplica el switch global general para todos"}
                </span>
              </div>
              <Switch
                $active={whitelist.shipmentsEnabledLocal}
                $color="#0284c7"
                onClick={() => whitelist.setShipmentsEnabledLocal((prev) => !prev)}
              />
            </div>

            <div style={{ display: "flex", flexDirection: "column", gap: "6px", marginTop: "4px" }}>
              <label style={{ fontWeight: "600", color: "#1f2937" }}>Mensaje para usuarios no autorizados o servicio deshabilitado:</label>
              <div style={{ display: "flex", gap: "10px", alignItems: "center", width: "100%" }}>
                <input
                  type="text"
                  value={whitelist.shipmentsDisabledMessage}
                  onChange={(e) => whitelist.setShipmentsDisabledMessage(e.target.value)}
                  placeholder="Ej: El servicio de envíos estará disponible próximamente en tu zona."
                  style={{
                    flex: 1,
                    backgroundColor: "#ffffff",
                    border: "1px solid #d1d5db",
                    borderRadius: "6px",
                    padding: "8px 12px",
                    color: "#1f2937",
                    outline: "none"
                  }}
                />
                <div style={{ flexShrink: 0 }}>
                  <VeryBtnFill
                    label={whitelist.savingShipmentsConfig ? "Guardando..." : "Guardar configuración de envíos"}
                    colorTheme={classVeryBtnFill.COLOR_THEME.BLACK_S1}
                    textSize={14}
                    isLoading={whitelist.savingShipmentsConfig}
                    onClick={whitelist.saveShipmentsConfig}
                  />
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {/* ========================================================================= */}
      {/* 3. SECCIÓN: SANDBOX (TESTERS)                                             */}
      {/* ========================================================================= */}
      {whitelist.mainTab === "SANDBOX" && (
        <div style={{
          backgroundColor: "#ffffff",
          border: "2px solid #000000",
          borderRadius: "8px",
          padding: "20px",
          marginBottom: "24px",
          color: "#1f2937",
          fontSize: "14px",
          lineHeight: "1.5",
          display: "flex",
          flexDirection: "column",
          gap: "12px"
        }}>
          <div style={{ fontWeight: "600", color: "#000000", display: "flex", alignItems: "center", gap: "8px", fontSize: "16px" }}>
            <span className="material-symbols-outlined" style={{ fontSize: "22px" }}>dns</span>
            Sandbox / Aislamiento de Pruebas en Producción y Dev
          </div>
          <div style={{ color: "#4b5563" }}>
            Los usuarios (pasajeros o conductores) agregados a esta lista tendrán activado su flag de tester (<strong>Modo Sandbox</strong>).
            Esto significa que quedarán aislados en su propio flujo de pruebas: los pasajeros testers <strong>solo verán y despacharán a conductores testers</strong>, evitando molestar o enviar solicitudes accidentales a conductores y clientes reales.
          </div>
        </div>
      )}

      {/* ========================================================================= */}
      {/* USER PICKER (BUSCADOR DE USUARIOS PARA AGREGAR A CUALQUIERA DE LAS LISTAS) */}
      {/* ========================================================================= */}
      <div className="divUserPicker">
        <div className="divPickerTabs">
          <button
            className={`btnPickerTab${whitelist.pickerType === "DRIVER" ? " active" : ""}`}
            onClick={() => whitelist.onChangePickerType("DRIVER")}
          >
            Conductores
          </button>
          <button
            className={`btnPickerTab${whitelist.pickerType === "PASSENGER" ? " active" : ""}`}
            onClick={() => whitelist.onChangePickerType("PASSENGER")}
          >
            Pasajeros
          </button>
        </div>
        <div className="divPickerSearchRow">
          <input
            className="inputPickerSearch"
            placeholder={`Buscar ${whitelist.pickerType === "DRIVER" ? "conductor" : "pasajero"} por nombre o teléfono...`}
            value={whitelist.pickerSearch}
            onChange={(e) => whitelist.setPickerSearch(e.target.value)}
            onKeyDown={(e) =>
              e.key === "Enter" && whitelist.searchPickerUsers()
            }
          />
          {whitelist.mainTab !== "SANDBOX" && (
            <select
              className="selectPickerAddType"
              value={whitelist.pickerAddType}
              onChange={(e) => whitelist.setPickerAddType(e.target.value)}
            >
              <option value="BOTH">Conductor + Pasajero</option>
              <option value="DRIVER">Solo Conductor</option>
              <option value="PASSENGER">Solo Pasajero</option>
            </select>
          )}
          <VeryBtnFill
            CSS={["btnPickerSearch"]}
            colorTheme={classVeryBtnFill.COLOR_THEME.BLACK_S1}
            icon={{
              name: "search",
              size: 16,
              type: classVeryIconGoogle.ICON_TYPE.SYMBOLS_OUTLINED,
            }}
            label="Buscar"
            onClick={() => whitelist.searchPickerUsers()}
          />
        </div>

        {whitelist.pickerResults.loading ? (
          <div className="divPickerLoading">
            <DivLoading size={36} weight={4} />
          </div>
        ) : pickerResultsEmpty ? (
          <div className="divPickerEmpty">
            <label className="txtPickerEmpty">
              {isStringEmpty(whitelist.pickerSearch)
                ? "Escribe un nombre o teléfono y presiona Buscar para encontrar usuarios."
                : `Sin resultados para "${whitelist.pickerSearch}"`}
            </label>
          </div>
        ) : (
          <VeryTable
            CSS={["pickerTable"]}
            rows={whitelist.pickerResults.list.map((u, i) => ({
              id: i,
              item: u,
            }))}
            getRowId={(row) => row.id}
            disabledRowSelection={true}
            columns={{
              col_name: classVeryTable.getColumnTemplate(
                "Nombre",
                "Nombre del usuario",
                0,
                220,
                160,
                true,
                true,
                (params) => params.row?.item?.name,
                (params) => params?.value,
              ),
              col_tel: classVeryTable.getColumnTemplate(
                "Teléfono",
                "Teléfono del usuario",
                1,
                160,
                120,
                true,
                true,
                (params) => params.row?.item?.tel,
                (params) => classVeryTable.renderColTel(params?.value, " "),
              ),
              col_add: classVeryTable.getColumnTemplate(
                "",
                "",
                2,
                160,
                130,
                false,
                false,
                undefined,
                (params) => {
                  const tel = params?.row?.item?.tel;
                  const userId = params?.row?.item?.id;
                  const isAdding = whitelist.addingTel === tel;
                  let btnLabel = "Agregar";
                  if (whitelist.mainTab === "SANDBOX") btnLabel = "Aislar (Tester)";
                  if (whitelist.mainTab === "SHIPMENTS") btnLabel = "Agregar a Envíos";

                  return (
                    <VeryBtnFill
                      CSS={["btnAddUser"]}
                      colorTheme={classVeryBtnFill.COLOR_THEME.BLACK_S1}
                      icon={{
                        name: "add",
                        size: 16,
                        type: classVeryIconGoogle.ICON_TYPE.SYMBOLS_OUTLINED,
                      }}
                      label={isAdding ? "Agregando..." : btnLabel}
                      onClick={() => {
                        if (!isAdding) {
                          if (whitelist.mainTab === "SANDBOX") {
                            whitelist.execAddTesterFromPicker(userId, tel);
                          } else if (whitelist.mainTab === "SHIPMENTS") {
                            whitelist.execAddFromPicker(tel, "SHIPMENTS");
                          } else {
                            whitelist.execAddFromPicker(tel, "APP");
                          }
                        }
                      }}
                    />
                  );
                },
              ),
            }}
          />
        )}
      </div>

      {/* ========================================================================= */}
      {/* TABLA DE RESULTADOS SEGÚN EL TAB ACTIVO                                   */}
      {/* ========================================================================= */}
      {whitelist.mainTab === "WHITELIST" && (
        <div className="divWhitelistSection">
          <label className="txtSectionTitle">Usuarios en Whitelist General ({whitelist.filteredList.length})</label>
          {listIsEmpty ? (
            <div className="divEmptyWhitelist">
              <label className="txtEmptyWhitelist">
                {isSearching
                  ? "No se encontraron coincidencias para la búsqueda."
                  : "No hay teléfonos en la whitelist general. La app está libre para todos."}
              </label>
            </div>
          ) : (
            <VeryTable
              CSS={["whitelistTable"]}
              rows={whitelist.filteredList}
              getRowId={(row) => row.id}
              disabledRowSelection={true}
              columns={{
                col_name: classVeryTable.getColumnTemplate(
                  "Nombre",
                  "Nombre del usuario",
                  0,
                  220,
                  160,
                  true,
                  true,
                  (params) => params.row?.item?.name || "Sin registrar",
                  (params) => params?.value,
                ),
                col_tel: classVeryTable.getColumnTemplate(
                  "Teléfono",
                  "Número de teléfono",
                  1,
                  200,
                  160,
                  true,
                  true,
                  (params) => params.row?.item?.tel,
                  (params) => classVeryTable.renderColTel(params?.value, " "),
                ),
                col_type: classVeryTable.getColumnTemplate(
                  "Tipo",
                  "Tipo de usuario",
                  2,
                  200,
                  160,
                  true,
                  true,
                  (params) => {
                    const type = params.row?.item?.userType;
                    if (type === "DRIVER") return "Solo Conductor";
                    if (type === "PASSENGER") return "Solo Pasajero";
                    return "Conductor + Pasajero";
                  },
                  (params) => params?.value,
                ),
                col_date: classVeryTable.getColumnTemplate(
                  "Fecha de registro",
                  "Fecha en que fue agregado",
                  3,
                  180,
                  150,
                  true,
                  true,
                  (params) => params.row?.item?.createdAt,
                  (params) => classVeryTable.renderColDate(params?.value),
                ),
                col_menu: classVeryTable.getColumnTemplate(
                  "",
                  "",
                  4,
                  80,
                  60,
                  false,
                  false,
                  undefined,
                  (params) => {
                    const items = [
                      {
                        label: "Eliminar",
                        loading: false,
                        onClick: () =>
                          whitelist.execDeleteFromWhitelist(
                            params?.row?.item?.id,
                            params?.row?.item?.tel,
                            "APP"
                          ),
                      },
                    ];
                    return classVeryTable.renderColMenu(items);
                  },
                ),
              }}
            />
          )}
        </div>
      )}

      {whitelist.mainTab === "SHIPMENTS" && (
        <div className="divWhitelistSection">
          <label className="txtSectionTitle">Usuarios con Acceso a Envíos ({whitelist.filteredShipmentsList.length})</label>
          {shipmentsListIsEmpty ? (
            <div className="divEmptyWhitelist">
              <label className="txtEmptyWhitelist">
                No hay usuarios en la lista exclusiva de envíos.
              </label>
            </div>
          ) : (
            <VeryTable
              CSS={["whitelistTable"]}
              rows={whitelist.filteredShipmentsList}
              getRowId={(row) => row.id}
              disabledRowSelection={true}
              columns={{
                col_name: classVeryTable.getColumnTemplate(
                  "Nombre",
                  "Nombre del usuario",
                  0,
                  220,
                  160,
                  true,
                  true,
                  (params) => params.row?.item?.name || "Sin registrar",
                  (params) => params?.value,
                ),
                col_tel: classVeryTable.getColumnTemplate(
                  "Teléfono",
                  "Número de teléfono",
                  1,
                  200,
                  160,
                  true,
                  true,
                  (params) => params.row?.item?.tel,
                  (params) => classVeryTable.renderColTel(params?.value, " "),
                ),
                col_type: classVeryTable.getColumnTemplate(
                  "Tipo",
                  "Tipo de usuario",
                  2,
                  200,
                  160,
                  true,
                  true,
                  (params) => {
                    const type = params.row?.item?.userType;
                    if (type === "DRIVER") return "Solo Conductor";
                    if (type === "PASSENGER") return "Solo Pasajero";
                    return "Conductor + Pasajero";
                  },
                  (params) => params?.value,
                ),
                col_date: classVeryTable.getColumnTemplate(
                  "Fecha de registro",
                  "Fecha en que fue agregado",
                  3,
                  180,
                  150,
                  true,
                  true,
                  (params) => params.row?.item?.createdAt,
                  (params) => classVeryTable.renderColDate(params?.value),
                ),
                col_menu: classVeryTable.getColumnTemplate(
                  "",
                  "",
                  4,
                  80,
                  60,
                  false,
                  false,
                  undefined,
                  (params) => {
                    const items = [
                      {
                        label: "Eliminar",
                        loading: false,
                        onClick: () =>
                          whitelist.execDeleteFromWhitelist(
                            params?.row?.item?.id,
                            params?.row?.item?.tel,
                            "SHIPMENTS"
                          ),
                      },
                    ];
                    return classVeryTable.renderColMenu(items);
                  },
                ),
              }}
            />
          )}
        </div>
      )}

      {whitelist.mainTab === "SANDBOX" && (
        <div className="divWhitelistSection">
          <label className="txtSectionTitle">Usuarios en Sandbox (Modo Tester)</label>
          {whitelist.testersList.length === 0 ? (
            <div className="divEmptyWhitelist">
              <label className="txtEmptyWhitelist">
                No hay usuarios marcados como testers en Sandbox.
              </label>
            </div>
          ) : (
            <VeryTable
              CSS={["whitelistTable"]}
              rows={whitelist.testersList}
              getRowId={(row) => row.id}
              disabledRowSelection={true}
              columns={{
                col_name: classVeryTable.getColumnTemplate(
                  "Nombre",
                  "Nombre del usuario",
                  0,
                  250,
                  200,
                  true,
                  true,
                  (params) => params.row?.name || "Sin registrar",
                  (params) => params?.value,
                ),
                col_tel: classVeryTable.getColumnTemplate(
                  "Teléfono",
                  "Número de teléfono",
                  1,
                  250,
                  200,
                  true,
                  true,
                  (params) => params.row?.tel,
                  (params) => classVeryTable.renderColTel(params?.value, " "),
                ),
                col_active: classVeryTable.getColumnTemplate(
                  "Sandbox Activo",
                  "Habilitar/Deshabilitar flujo aislado para este usuario",
                  2,
                  150,
                  130,
                  false,
                  false,
                  undefined,
                  (params) => {
                    const isActive = params.row?.isTester === 1;
                    const userId = params.row?.id;
                    const tel = params.row?.tel;
                    return (
                      <Switch
                        $active={isActive}
                        $color="#000000"
                        onClick={() =>
                          whitelist.execToggleUserTesterState(userId, !isActive, tel)
                        }
                      />
                    );
                  },
                ),
                col_menu: classVeryTable.getColumnTemplate(
                  "",
                  "",
                  3,
                  120,
                  100,
                  false,
                  false,
                  undefined,
                  (params) => {
                    const items = [
                      {
                        label: "Quitar de Sandbox",
                        loading: false,
                        onClick: () =>
                          whitelist.execRemoveTester(
                            params?.row?.id,
                            params?.row?.tel,
                          ),
                      },
                    ];
                    return classVeryTable.renderColMenu(items);
                  },
                ),
              }}
            />
          )}
        </div>
      )}
    </styles.DivMain>
  );
};

export default ContentWhitelistPage;
